module.exports = __webpack_public_path__ + "img/jbcx.d54fdb5c.jpg";